import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";

import SvgIcons from "../../Icons/SvgIcons";
import {setWizardFlowActiveMode} from "../wizardFlowActions";
import {WIZARD_GROUP_TYPES} from "../WizardItem/wizardItemInterface";
import {getFilterValuesByGroup} from "../../FeatureCreator/FeaturesFilters/FeaturesFiltersActions";
import WizardGroupsAsideSortableItems from "./WizardGroupsAsideSortableItems";
import {setWizardFiltersLoading} from "../wizardActions";
import useGetAllFiltersGroups from "../../FeatureCreator/FeaturesFilters/useGetAllFiltersGroups";

const getNotReceivedWizardGroupFilters = (wizardGroups, filtersReceived) => {
  let notReceivedWizardGroupFilters = [];
  wizardGroups.forEach(wizardGroup => {
    if (wizardGroup.nodeType === WIZARD_GROUP_TYPES.group && !filtersReceived[wizardGroup.groupName]
      && !notReceivedWizardGroupFilters.some(wizGroup => wizGroup.groupName === wizardGroup.groupName)) {
      notReceivedWizardGroupFilters.push(wizardGroup)
    }
  })
  return notReceivedWizardGroupFilters
}

const WizardGroupsAside = (props) => {

  const {wizardActiveItem, wizardFlowActiveMode, setWizardFlowActiveMode, allFilterGroups, filtersReceived,
    setWizardFiltersLoading, wizardFiltersLoading, featureGroupsLoading} = props;
  const [searchText, setSearchText] = useState("");

  const {wizardGroups} = wizardActiveItem;
  let notReceivedWizardGroupFilters = getNotReceivedWizardGroupFilters(wizardGroups, filtersReceived);

  useGetAllFiltersGroups(allFilterGroups);

  const checkFiltersForGroups = async () => {
    setWizardFiltersLoading(true);
    for (const wizardGroup of notReceivedWizardGroupFilters) {
      await getFilterValuesByGroup(wizardGroup.groupName);
    }
    setWizardFiltersLoading(false);
  }

  useEffect(() => {
    if (wizardFlowActiveMode === WIZARD_GROUP_TYPES.filter && notReceivedWizardGroupFilters.length) {
      checkFiltersForGroups()
    }
  }, [wizardFlowActiveMode]);

  useEffect(() => {
    if (!wizardGroups.some(wizardGroup => wizardGroup.nodeType === WIZARD_GROUP_TYPES.filter)) {
      return
    }
    if (notReceivedWizardGroupFilters.length) { // first load
      checkFiltersForGroups()
    }
  }, []);

  return (
    <aside className="assign-sidebar wizard-sidebar">
      <div className="wizard-sidebar__top">
        {Object.keys(WIZARD_GROUP_TYPES).map(buttonMode => {
          if (buttonMode !== WIZARD_GROUP_TYPES.group || buttonMode !== WIZARD_GROUP_TYPES.filter) {
            return null
          }
          return (
            <div className="wizard-sidebar__top-button" key={buttonMode}>
              <button className={"ui-icon-gray" + (wizardFlowActiveMode === buttonMode ? " ui-icon-gray--active" : "")}
                      onClick={() => setWizardFlowActiveMode(buttonMode)}>
                {SvgIcons[buttonMode]}
              </button>
            </div>
          )
        })}
        <input type="text" className="ui-input ui-input--gray3 ui-input--r3" placeholder="Search" value={searchText}
               onChange={e => setSearchText(e.target.value)} />
      </div>
      {featureGroupsLoading || (wizardFiltersLoading && (wizardFlowActiveMode === WIZARD_GROUP_TYPES.filter))
        ? <div className="ui-loader"/>
        : <WizardGroupsAsideSortableItems wizardActiveItem={wizardActiveItem}
                                          searchText={searchText}
                                          notReceivedWizardGroupFilters={notReceivedWizardGroupFilters} />}
    </aside>
  )
};

WizardGroupsAside.propTypes = {
  wizardActiveItem: PropTypes.object.isRequired
}

const mapStateToProps = (store) => {
  const {wizardFlowActiveMode, wizardFiltersLoading} = store.wizardState;
  const {allFilterGroups, filtersReceived} = store.featuresFiltersState; //todo
  const {loading} = store.projectScopeNew;

  return {
    wizardFlowActiveMode,
    wizardFiltersLoading,
    allFilterGroups,
    filtersReceived,
    featureGroupsLoading: loading,
  };
};

const mapDispatchToProps = {
  setWizardFlowActiveMode,
  setWizardFiltersLoading,
};

export default connect(mapStateToProps, mapDispatchToProps)(WizardGroupsAside)
